/// ROUTER ///
import { useNavigate } from "react-router-dom";
/// FM ///
import { motion } from "framer-motion";
/// MUI ///
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
/// DATE ///
import { DateTime } from "luxon";

interface Props {
  title: string,
  time: string,
  color: string,
  url: string
}

export default function DayEvent({ title, time, color, url }: Props) {
  const navigate = useNavigate();
  const theme = useTheme();
  const is_sm = useMediaQuery(theme.breakpoints.up("sm"));

  return (
    <motion.button
      initial={{ scale: 1 }}
      whileHover={{ scale: 1.03 }}
      style={{
        backgroundColor: `${color ?? "blue"}`,
        width: is_sm ? "300px" : "100%",
        display: "flex",
        flexDirection: is_sm ? "column" : "row",
        justifyContent: is_sm ? "start" : "space-between",
        borderRadius: "5px",
        paddingTop: is_sm ? "10px" : "4px",
        paddingBottom: is_sm ? "10px" : "4px",
        paddingLeft: is_sm ? "15px" : "8px",
        paddingRight: is_sm ? "15px" : "8px",
        marginRight: is_sm ? "5px" : "0px",
        marginLeft: is_sm ? "5px" : "0px",
        cursor: "pointer",
        border: "none"
      }}
      onClick={() => navigate(url)}>
        <Typography variant="body2" align="left" sx={{ color: "#fff" }}>
          {title}
        </Typography>
        <Typography variant="body2" sx={{ marginTop: is_sm ? "25px" : "0px", color: "#fff" }}>
          {DateTime.fromISO(time).toLocal().toFormat("h:mm a")}
        </Typography>
    </motion.button>
  )
}

